"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
gsap.registerPlugin(useGSAP);
export default function Contactohero() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".reveal", {
        y: 24
      });
      gsap.to(".reveal", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.12,
        ease: "power3.out"
      });
      gsap.to(".emphasis-word", {
        opacity: 1,
        y: 0,
        duration: 0.4,
        delay: 0.2 + 0.12 * 2,
        ease: "power2.out"
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".reveal", ".emphasis-word"], {
        opacity: 1,
        y: 0
      });
    });
  }, {
    scope: container
  });
  return <section data-section-id="28076" id="contactohero" data-nav="light" ref={container} className="bg-background text-foreground py-[clamp(112px,16vh,192px)]">
      <div className="mx-auto max-w-[1200px] px-5 sm:px-8 lg:px-24">
        <div className="flex flex-col items-center text-center">
          <div className="reveal" style={{
          opacity: 0
        }}>
            <Breadcrumb>
              <BreadcrumbList className="justify-center text-[color:var(--muted-foreground)]">
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/HomePage" className="text-[color:var(--muted-foreground)] hover:text-[color:var(--foreground)] text-[0.8125rem] tracking-[0.02em]">
                      Inicio
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="text-[color:var(--muted-foreground)]" />
                <BreadcrumbItem>
                  <BreadcrumbPage className="text-[color:var(--foreground)] text-[0.8125rem] tracking-[0.02em]">
                    Contacto
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          <div className="reveal mt-12" style={{
          opacity: 0
        }}>
            <span className="text-[0.75rem] font-semibold uppercase leading-none tracking-[0.14em] text-[color:var(--primary)]">
              Contacto
            </span>
          </div>

          <h1 className="reveal font-default mt-8 max-w-[1100px] text-[color:var(--foreground)] font-extrabold" style={{
          opacity: 0,
          fontSize: "clamp(3.75rem, 11vw, 10.5rem)",
          letterSpacing: "-0.03em",
          lineHeight: "0.88"
        }}>
            Contacta con{" "}
            <span className="emphasis-word inline-block text-[color:var(--primary)]" style={{
            opacity: 0,
            transform: "translateY(6px)"
          }}>
              Servicios de reparaciones
            </span>
          </h1>

          <p className="reveal mt-10 max-w-[640px] text-[color:var(--muted-foreground)]" style={{
          opacity: 0,
          fontSize: "clamp(1.0625rem, 1.1vw, 1.25rem)",
          lineHeight: "1.55"
        }}>
            Estamos listos para ayudarte con tu reparación o mantenimiento en Totana, Murcia, Alicante y Almería. Presupuesto gratis y urgencias 24 horas.
          </p>

          <div className="reveal mt-14 flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center justify-center gap-3 sm:gap-4 w-full sm:w-auto" style={{
          opacity: 0
        }}>
            <Button asChild className="h-14 rounded-lg bg-[#25D366] hover:bg-[#20bd5a] text-white px-8 text-base font-medium transition-colors w-full sm:w-auto shadow-xs border-0">
              <Link to="https://wa.me/34657068444" newTab>
                Escríbenos por WhatsApp
              </Link>
            </Button>
            <Button asChild variant="outline" className="h-14 rounded-lg border-[1.5px] border-[color:var(--foreground)] bg-transparent px-8 text-[color:var(--foreground)] hover:bg-[color:var(--foreground)] hover:text-[color:var(--background)] text-base font-medium transition-colors w-full sm:w-auto">
              <Link to="tel:+34657068444">+34 657 068 444</Link>
            </Button>
          </div>

          <p className="reveal mt-6 text-[0.8125rem] font-medium tracking-[0.02em] text-[color:var(--muted-foreground)]" style={{
          opacity: 0
        }}>
            Urgencias 24 horas.
          </p>
        </div>
      </div>
    </section>;
}